"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectIn = exports.proxySessionStorageApi = exports.proxyLocalStorageApi = exports.isOverflownVertical = exports.isOverflownHorizontal = exports.isOverflown = exports.isDefined = exports.isBrowserReady = exports.getFileThumbnail = void 0;
var _lodash = require("lodash");
var _router = require("@reach/router");
const isBrowserReady = () => typeof window !== 'undefined';
exports.isBrowserReady = isBrowserReady;
const isDefined = v => v !== undefined && v !== null && v !== 'null' && v !== 'undefined';
exports.isDefined = isDefined;
const proxyLocalStorageApi = function (method) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return isBrowserReady() ? (0, _lodash.invoke)(window.localStorage, method, ...args) : null;
};
exports.proxyLocalStorageApi = proxyLocalStorageApi;
const proxySessionStorageApi = function (method) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  return isBrowserReady() ? (0, _lodash.invoke)(window.sessionStorage, method, ...args) : null;
};
exports.proxySessionStorageApi = proxySessionStorageApi;
const redirectIn = function () {
  let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  let interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  return setTimeout(() => {
    (0, _router.navigate)(path);
  }, [interval]);
};
exports.redirectIn = redirectIn;
const isOverflownHorizontal = _ref => {
  let {
    clientWidth,
    scrollWidth
  } = _ref;
  return scrollWidth > clientWidth;
};
exports.isOverflownHorizontal = isOverflownHorizontal;
const isOverflownVertical = _ref2 => {
  let {
    clientHeight,
    scrollHeight
  } = _ref2;
  return scrollHeight > clientHeight;
};
exports.isOverflownVertical = isOverflownVertical;
const isOverflown = el => isOverflownVertical(el) || isOverflownHorizontal(el);
exports.isOverflown = isOverflown;
const getFileThumbnail = (file, callback) => {
  const reader = new FileReader();
  if (file) {
    reader.readAsDataURL(file);
    reader.onload = e => {
      callback(null, e.currentTarget.result);
    };
    reader.onerror = e => {
      callback(e);
    };
  }
};
exports.getFileThumbnail = getFileThumbnail;